const RBAC_BASE_URL = '/rbac';
const isNode = typeof window === 'undefined';

export { RBAC_BASE_URL, isNode };
